angular.module('signalview.orgUsageChart', [
    'signalboost',
    'sfx.ui',
    'sfx.data',
    'signalview.sfGlobalNav',
    'signalview.orgSubscription',
    'lineviz',
]);
